
import Vue from 'vue';
import InfoCard from '@/components/misc/InfoCard.vue';
import ViewsTable from '@/components/entities/view/ViewsTable.vue';
import ViewCreateDialog from '@/components/entities/view/ViewCreateDialog.vue';
import ViewService from '@/services/ViewService';
import { extractErrorMessage } from '@/utils/Util';

export default Vue.extend({
  name: 'ViewsView',
  components: { ViewsTable, ViewCreateDialog, InfoCard },
  data: () => ({
    views: [] as any[],
    dataLoaded: false,
    dataError: false,
    alertText: '',
    alertType: 'error',
    filters: {} as any,
  }),
  created() {
    this.update();
  },
  watch: {
    currentTenant() {
      this.filters = {};
      this.update();
    },
  },
  methods: {
    onTableReload() {
      this.update();
    },
    onItemUpdate(item: any) {
      this.views.splice(
        this.views.findIndex((v: any) => v.uuid === item.uuid),
        1
      );
      this.views.push(item);
    },
    onItemDelete(item: any) {
      this.views.splice(
        this.views.findIndex((v: any) => v.uuid === item.uuid),
        1
      );
    },
    onCreation(view: any) {
      this.views.push(view);
    },
    update() {
      this.views = [];
      this.dataLoaded = false;
      this.dataError = false;

      const params = {};
      Object.assign(params, this.filters);

      ViewService.getAllCollectionPages(this.currentTenant, params)
        .then((views: any[]) => {
          this.dataLoaded = true;
          this.views = views;
        })
        .catch((err: any) => {
          console.log(err, err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('views.loadingError') + ' ' + extractErrorMessage(err);
          this.dataError = true;
          this.dataLoaded = true;
        });
    },
  },
  computed: {
    currentTenant(): any {
      return this.$root.$store.state.session.selectedTenant.uuid;
    },
    canCreate(): any {
      const res = this.$root.$store.state.session.permissions.resources;
      return res && 'views' in res ? res['views'].includes('POST') : false;
    },
    lastCreatedAt(): any {
      let sum = 0;
      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate() - 7);

      this.views.forEach((obj: any) => {
        const d = new Date(obj.createdAt);
        if (d >= pastDate) sum++;
      });

      return sum;
    },
  },
});
